<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-pagos"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { formatearValorAMoneda, valueFormatterMoneda } from '../utils/funciones';

export default {
  name: 'ListadoSolicitudesPagos',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° SOLICITUD',
          field: 'numeroSolicitud',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'CONCEPTO',
          field: 'detallePlanPagoConceptoUniversidad.planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'SOLICITANTE',
          field: 'nombreSolicitante',
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'SE REALIZARON PAGOS',
          cellRenderer: (params) => {
            const conPagos = params.data?.pagosUniversidades?.length > 0;
            const color = conPagos ? 'green' : 'red';

            return /*html*/ `
              <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                  <span class="v-chip__content"> ${conPagos ? 'SI' : 'NO'}</span>
              </span>
            `;
          },
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'N° CUOTA',
          field: 'numeroCuota',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'MONTO',
          field: 'monto',
          type: 'numericColumn',
          valueFormatter: valueFormatterMoneda,
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'N° ESTUDIANTES',
          cellRenderer: (params) => {
            return params.data?.detallesSolicitudesPagos?.length || 0;
          },
          type: 'numericColumn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'MONTO TOTAL',
          cellRenderer: (params) => {
            const montoTotal = (params.data?.monto * params.data?.detallesSolicitudesPagos?.length).toFixed(2);

            return formatearValorAMoneda(montoTotal);
          },
          type: 'numericColumn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'SEDE',
          field: 'sede.nombre',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-pagos {
  height: calc(var(--vh, 1vh) * 100 - 24rem);
}
</style>
  